import React from "react";

export default function CategoryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2 3.5C2 2.11929 3.11929 1 4.5 1H13.5C14.8807 1 16 2.11929 16 3.5V6H15V3.5C15 2.67157 14.3284 2 13.5 2H4.5C3.67157 2 3 2.67157 3 3.5V12.5C3 13.3284 3.67157 14 4.5 14H8V15H4.5C3.11929 15 2 13.8807 2 12.5V3.5ZM5.5 6H11C10.1115 6 9.31321 6.38625 8.76389 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6ZM8.17071 8H5.5C5.22386 8 5 8.22386 5 8.5C5 8.77614 5.22386 9 5.5 9L8 9C8 8.64936 8.06015 8.31278 8.17071 8ZM5.5 4C5.22386 4 5 4.22386 5 4.5C5 4.77614 5.22386 5 5.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H5.5ZM18 9C18 7.89543 17.1046 7 16 7H11C9.89543 7 9 7.89543 9 9V17C9 18.1046 9.89543 19 11 19H17.5C17.7761 19 18 18.7761 18 18.5C18 18.2239 17.7761 18 17.5 18H11C10.4477 18 10 17.5523 10 17V16.9969H17.5C17.7761 16.9969 18 16.7731 18 16.4969V9ZM10 15.9969V9C10 8.44771 10.4477 8 11 8H16C16.5523 8 17 8.44772 17 9V15.9969H10Z"
        fill="#262626"
      />
    </svg>
  );
}
